import { jwtDecode } from 'jwt-decode';
import { userModel } from '../Interfaces';
import toastNotify from './toastNotify';
import { getAuthToken, storeAuthToken } from './authToken';

export const getJWTtoken = () => {
  return getAuthToken();
};

export const authJWTDecode = () => {
  const token = getJWTtoken();
  if (token) {
    const userDetail: userModel = jwtDecode(token);
    return userDetail;
  } else {
    return null;
  }
};

export const apiCall = async (
  endpoint: string,
  body: any = {},
  isNeedToken = false,
  method = 'POST',
  isRedirect401 = true,
  redirectPath = localStorage.getItem('loginUrl')
): Promise<{
  statusCode?: number;
  isSuccess?: boolean;
  errorMessages?: Array<string>;
  result: any;
} | null> => {
  try {
    const token = getAuthToken();
    const headers: HeadersInit = {
      'Content-Type': 'application/json',
    };

    // Add Authorization only if token exists
    if (token && isNeedToken) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await fetch(
      `${process.env.REACT_APP_APIBaseUrl}/${endpoint}`,
      {
        method,
        headers,
        body: method !== 'GET' ? JSON.stringify(body) : null, // Ensure GET requests don't have a body
      }
    );

    const result: {
      statusCode?: number;
      isSuccess?: boolean;
      errorMessages?: Array<string>;
      result: any;
    } = await response.json();

    // If statusCode is 401, redirect to login
    if (result.statusCode === 401 && isRedirect401) {
      console.log('call 401 api');

      toastNotify('Session expired! Redirecting to login...', 'error');
      window.location.href = redirectPath!; // Redirect to login page
      return null;
    }

    // If API call failed, show error messages
    if (!result.isSuccess) {
      toastNotify(result.errorMessages?.join('<br />')!, 'error');
      return null;
    }

    return result; // Return response
  } catch (error) {
    console.error('API Call Failed:', error);
    toastNotify('Network Error!', 'error');
    return null; // Handle errors gracefully
  }
};

export const authApiCall = async (
  endpoint: string,
  body: any,
  returnUrl: string = '/'
): Promise<{
  statusCode?: number;
  isSuccess?: boolean;
  errorMessages?: Array<string>;
  result: any;
} | null> => {
  try {
    toastNotify('This login can only work in deploy part', 'info');

    const token = getAuthToken()!;

    const userDetail: userModel = jwtDecode(token);
    storeAuthToken(token);

    return {
      isSuccess: true,
      statusCode: 200,
      result: userDetail,
    };
  } catch (error) {
    console.error('API Call Failed:', error);
    toastNotify('Network Error!', 'error');
    return null; // Handle errors gracefully
  }
};

export const logoutApiCall = async (returnUrl: string = '/') => {
  toastNotify('This logout can only work in deploy part', 'info');
  try {
    return {
      isSuccess: true,
      statusCode: 200,
    };
  } catch (error) {
    console.error('API Call Failed:', error);
    toastNotify('Network Error!', 'error');
    return null; // Handle errors gracefully
  }
};

export const authenticationCheck = () => {};
